import type { NonEmptyArray } from '../types';

export const getElement = <T>(
  array: Readonly<NonEmptyArray<T>>,
  index: number,
): T => {
  return array[index % array.length] ?? array[0];
};
